import { CreatePartFinderReportRequest } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { PART_FINDER_REPORTS_QUERY_KEY } from './query';

export const useCreatePartFinderReport = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: string) => void;
} = {}) => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  const { mutateAsync, isPending, error } = useMutation({
    mutationFn: (data: CreatePartFinderReportRequest) => api.tenants.createPartFinderReport(tenantId, data),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: [PART_FINDER_REPORTS_QUERY_KEY], exact: false });
      onSuccess?.();
    },
    onError: (error: AxiosError<{ message: string }>) => {
      onError?.(error.response?.data.message ?? 'Failed to create part finder report');
    },
  });

  return {
    mutateAsync,
    isPending,
    error,
  };
};
